import Home from './components/Home'
import NotFound from './components/NotFound'
import Util from './helpers/Util'

const checkForPermissions = (to, from, next) => {
  if (Util.HasPermission(to.meta.requiredPermission)) {
    next()
    return
  } else {
    if (to.meta.fallback) {
      next(to.meta.fallback)
      return
    }
  }

  next('/app')
}

export default {
  mode: 'history',
  routes: [
    {
      path: '/home',
      redirect: { name: 'home' }
    },
    {
      path: '/app',
      component: Home,
      name: 'home'
    },
    {
      path: '/app/admin/clients',
      component: () => import('./components/company/CompanyList'),
      name: 'companies',
      beforeEnter: checkForPermissions,
      meta: { requiredPermission: 'Onboarding' }
    },
    {
      path: '/app/admin/clients/create',
      component: () => import('./components/company/CompanyAddEdit'),
      name: 'company-add-edit',
      props: true,
      beforeEnter: checkForPermissions,
      meta: { requiredPermission: 'Onboarding' }
    },
    {
      path: '/app/admin/clients/:id/edit',
      component: () => import('./components/company/CompanyAddEdit'),
      name: 'company-edit',
      props: true,
      beforeEnter: checkForPermissions,
      meta: { requiredPermission: 'Onboarding,Practice Admin' }
    },
    {
      path: '/app/admin/clients/:id/stripe',
      component: () => import('./components/company/CompanyStripeForm'),
      name: 'company-stripe-form',
      props: true,
      beforeEnter: checkForPermissions,
      meta: { requiredPermission: 'Onboarding,Practice Admin' }
    },
    {
      path: '/app/admin/clients/:id',
      component: () => import('./components/company/CompanyDetail'),
      name: 'company-detail',
      beforeEnter: checkForPermissions,
      meta: { requiredPermission: 'Onboarding' }
    },
    {
      path: '/app/company',
      component: () => import('./components/company/CompanyDetail'),
      name: 'company-detail-self',
      beforeEnter: checkForPermissions,
      meta: { requiredPermission: 'Onboarding,Practice Admin' }
    },
    {
      path: '/app/user',
      name: 'user',
      component: () => import('./components/user/UserMain'),
      children: [
        {
          path: 'settings',
          name: 'user-settings',
          component: () => import('./components/user/UserSettings')
        }
      ]
    },
    {
      path: '/app/admin/accounts',
      component: () => import('./components/account/Index'),
      name: 'account'
    },
    {
      path: '/app/admin/accounts/new',
      component: () => import('./components/account/AddMember'),
      name: 'account-new'
    },
    {
      path: '/app/admin/accounts/:id',
      component: () => import('./components/account/AccountDetail'),
      name: 'account-detail'
    },
    {
      path: '/app/admin/accounts/:id/members',
      component: () => import('./components/account/AddMember'),
      name: 'account-add-member',
      props: true
    },
    {
      path: '/app/admin/accounts/:id/members/reactivate',
      component: () => import('./components/account/ReactivateMembers'),
      name: 'account-reactivate-members'
    },
    {
      path: '/app/admin/accounts/:id/members/deactivate',
      component: () => import('./components/account/DeactivateMembers'),
      name: 'account-deactivate-members'
    },
    {
      path: '/app/admin/accounts/:id/update-card',
      component: () => import('./components/account/AccountUpdateCard'),
      name: 'account-update-card'
    },
    {
      path: '/app/admin/accounts/:id/oneoff-charge',
      component: () => import('./components/account/OneOffCharge'),
      name: 'account-oneoff-charge'
    },
    {
      path: '/app/admin/accounts/:id/oneoff-charge/:invoiceId',
      component: () => import('./components/account/OneOffCharge'),
      name: 'account-oneoff-charge-invoice'
    },
    {
      path: '/app/admin/members',
      component: () => import('./components/member/Index'),
      name: 'member'
    },
    {
      path: '/app/admin/members/:id',
      component: () => import('./components/member/MemberDetail'),
      name: 'member-detail'
    },
    {
      path: '/app/admin/members/:id/edit',
      component: () => import('./components/account/MemberInfo'),
      name: 'member-info',
      props: true
    },
    {
      path: '/app/admin/members/:id/edit-plan',
      component: () => import('./components/member/EditPlan'),
      name: 'edit-plan'
    },
    {
      path: '/app/downloads',
      component: () =>
        import('./components/general/DownloadApplications'),
      name: 'download-applications'
    },
    {
      path: '/app/feedback',
      component: () => import('./components/general/FeedbackForm'),
      name: 'feedback-form'
    },
    {
      path: '/app/companies/:id/payments',
      component: () => import('./components/payment/Index'),
      name: 'payment'
    },
    {
      path: '/app/accounts/:id/update-card',
      component: () => import('./components/payment/UpdateCard'),
      name: 'update-card'
    },
    {
      path: '/app/accounts/:id/billing-receipt',
      component: () =>
        import('./components/payment/PaymentBillingReceipt'),
      name: 'billing-receipt',
      props: true
    },
    {
      path: '/app/accounts/:id/subscription/update-billing-date',
      component: () => import('./components/payment/UpdateBillingDate'),
      name: 'update-billing-date',
      props: true
    },
    {
      path: '/app/invoice/:id/transaction-details',
      component: () =>
        import('./components/account/AccountTransactionDetail'),
      name: 'account-transaction-details',
      props: true
    },
    {
      path: '/app/accounts/:id/edit-frequency',
      component: () =>
        import('./components/account/AccountEditFrequency'),
      name: 'edit-frequency',
      props: true
    },
    {
      path: '/app/admin/rewards',
      component: () => import('./components/reward/Index'),
      name: 'reward'
    },
    {
      path: '/app/admin/member/:id/rewards',
      component: () => import('./components/member/MemberRewardForm'),
      name: 'member-reward-form'
    },
    {
      path: '/app/admin/member/:id/confirm-rewards',
      component: () => import('./components/member/MemberRewardConfirm'),
      name: 'member-reward-confirm'
    },
    {
      path: '/app/admin/member/:id/rewards-instruction',
      component: () =>
        import('./components/member/MemberRewardInstruction'),
      name: 'member-reward-instruction'
    },
    {
      path: '/app/admin/member/:id/rewards-history',
      component: () => import('./components/member/MemberRewardHistory'),
      name: 'member-reward-history'
    },
    {
      path: '/app/visit',
      name: 'visit',
      component: () => import('./components/visit/Index'),
      children: [
        {
          path: 'lookup',
          name: 'visit-member-lookup',
          component: () =>
            import('./components/visit/VisitMemberLookup')
        },
        {
          path: 'log/:id',
          name: 'log-consistent-care',
          component: () =>
            import('./components/member/MemberDetail')
        }
      ]
    },
    {
      path: '/app/admin/schedule',
      component: () => import('./components/schedule/Index'),
      name: 'schedule'
    },
    {
      path: '/app/reports/',
      component: () => import('./components/report/Index'),
      name: 'reports',
      beforeEnter: checkForPermissions,
      meta: { requiredPermission: 'Onboarding,Practice Admin' }
    },
    {
      path: '*',
      component: NotFound
    },
    {
      path: '/guest',
      name: 'guest',
      component: () => import('./components/guest/Index'),
      children: [
        {
          path: 'verify-email',
          name: 'guest-email-verification',
          component: () =>
            import('./components/guest/EmailVerification')
        },
        {
          path: 'update-payment-redirect',
          name: 'guest-update-payment-redirect',
          component: () =>
            import('./components/guest/UpdatePaymentRedirect')
        },
        {
          path: 'payment-update/success',
          name: 'guest-update-payment-success',
          component: () =>
            import('./components/guest/UpdatePaymentSuccess')
        },
        {
          path: 'payment-update/cancel',
          name: 'guest-update-payment-canceled',
          component: () =>
            import('./components/guest/UpdatePaymentCanceled')
        }
      ]
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('./pages/Signup')
    },
    {
      path: '/training',
      name: 'training',
      component: () => import('./pages/Training')
    },
    {
      path: '/app/companies/claims',
      component: () => import('./components/payout/Claim'),
      name: 'payouts'
    },
    {
      path: '/app/member',
      name: 'member-portal',
      component: () => import('./pages/MemberPortal'),
      children: [
        {
          path: 'detail',
          name: 'member-portal-detail',
          component: () => import('./components/portal/MemberDetail.vue')
        },
        {
          path: 'update-card',
          component: () => import('./components/portal/UpdateCard.vue'),
          name: 'member-portal-update-card',
          props: true
        },
        {
          path: 'member-plan',
          component: () => import('./components/portal/PlanTab.vue'),
          name: 'member-portal-plan',
          props: true
        },
        {
          path: 'invoice/:id/transaction-details',
          name: 'member-account-transaction-details',
          component: () =>
            import('./components/account/AccountTransactionDetail'),
          props: true
        },
      ]
    },
  ]
}
